import {
	type OpeningHourException,
	apiAppBusinessOpeninghourSearchspecialopeninghours
} from '#lib/types/generated/index.js';
import { DateTime } from 'luxon';
import { get, writable } from 'svelte/store';
import { businessStore } from './business';
import { calendarDateRange } from './calendarDates';

export const openingHourExceptionStore = writable<Array<OpeningHourException>>([]);
export const openingHourExceptionDaysStore = writable<Record<string, OpeningHourException[]>>({});

let startDateLoaded: DateTime | null = null;
let endDateLoaded: DateTime | null = null;

export function initOpeningHourExceptions(
	items: OpeningHourException[],
	start: DateTime,
	end: DateTime
): void {
	startDateLoaded = start;
	endDateLoaded = end;
	openingHourExceptionStore.set(items);
}

export function clearOpeningHourExceptions(): void {
	startDateLoaded = null;
	endDateLoaded = null;
	openingHourExceptionStore.set([]);
}

openingHourExceptionStore.subscribe((value) => {
	const days: Record<string, OpeningHourException[] | undefined> = {};
	value.forEach((exception) => {
		for (
			let date = exception.startDate;
			date <= exception.endDate;
			date = date.plus({ days: 1 })
		) {
			const key = date.toISODate();
			if (!key) continue;
			if (!days[key]) {
				days[key] = [];
			}
			days[key].push(exception);
		}
	});
	openingHourExceptionDaysStore.set(days as Record<string, OpeningHourException[]>);
});

export function loadExceptions(
	startDate: DateTime | undefined = undefined,
	endDate: DateTime | undefined = undefined
): Promise<void> {
	if (!get(businessStore).id) return Promise.resolve();
	const start =
		startDate ??
		(startDateLoaded
			? DateTime.min(get(calendarDateRange).start, startDateLoaded)
			: get(calendarDateRange).start);
	const end =
		endDate ??
		(endDateLoaded
			? DateTime.max(get(calendarDateRange).end, endDateLoaded)
			: get(calendarDateRange).end);
	return apiAppBusinessOpeninghourSearchspecialopeninghours({
		startDate: start.toISODate(),
		endDate: end.toISODate()
	}).then((res) => {
		startDateLoaded = start;
		endDateLoaded = end;
		openingHourExceptionStore.set(res.items);
	});
}

calendarDateRange.subscribe((range) => {
	if (!get(businessStore).id) return;
	const startIso = range.start.toISODate();
	const endIso = range.end.toISODate();
	const loadedStartIso = startDateLoaded?.toISODate();
	const loadedEndIso = endDateLoaded?.toISODate();

	if (
		startIso &&
		endIso &&
		loadedStartIso &&
		loadedEndIso &&
		startIso >= loadedStartIso &&
		endIso <= loadedEndIso
	) {
		return;
	}
	loadExceptions();
});
